import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";

import CardIndividual from "../CardIndividual/CardIndividual";
import Loader from "../Loader/Loader";
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import WhatsApp from "../WhatsApp/WhatsApp";

const normalizarMarca = (marca) => {
  return marca
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");
};

const VehiculosPorMarca = () => {
  const { marca } = useParams();

  const [vehiculos, setVehiculos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const storage = getStorage();

    const folderRef = ref(storage, "Autos/nuevos");

    listAll(folderRef)
      .then((res) => {
        return Promise.all(
          res.prefixes.map((folder) => {
            return listAll(folder).then((res) => {
              const imageFiles = res.items.filter(
                (item) => !item.name.endsWith(".json")
              );

              const jsonFile = res.items.find((item) =>
                item.name.endsWith(".json")
              );

              if (!jsonFile || imageFiles.length === 0) {
                return null;
              }

              return Promise.all([
                getDownloadURL(imageFiles[0]),
                getDownloadURL(jsonFile),
              ]).then(([imageUrl, jsonUrl]) => {
                return fetch(jsonUrl)
                  .then((response) => response.json())
                  .then((jsonData) => {
                    const marcaNormalizada = normalizarMarca(
                      jsonData.Marca || ""
                    );

                    if (marcaNormalizada !== marca) {
                      return null;
                    }

                    return {
                      url: imageUrl,
                      modelo: jsonData.Modelo,
                      marca: jsonData.Marca,
                      año: jsonData.Año,
                      folderName: folder.name,
                    };
                  });
              });
            });
          })
        );
      })
      .then((resultados) => {
        setVehiculos(resultados.filter(Boolean));

        setIsLoading(false);

        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, [marca]);

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300">
      <div className="container mx-auto px-4 py-8">

        <h1 className="text-center text-4xl font-bold mb-10 uppercase">
          {marca}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vehiculos.map((vehicle) => (
            <div
              key={vehicle.folderName}
              className="flex justify-center"
            >
              <CardIndividual
                image={vehicle.url}
                name={vehicle.modelo}
                onInfoClick={() =>
                  navigate(`/nuevos/${vehicle.folderName}`)
                }
              />
            </div>
          ))}
        </div>

      </div>

      <WhatsApp />
      <NavigationButtons />
    </div>
  );
};

export default VehiculosPorMarca;